module.exports = __webpack_public_path__ + "static/media/c22.df65231d.png";